import { OAuthPasswordReturn } from '../contexts/PasswordRequestContext'

export function getOAuthReturnPath(
  value: OAuthPasswordReturn | undefined,
  email: string
): string | undefined {
  if (
    value &&
    /^[\w-]{43}$/.test(value.interactionId) &&
    value.email.trim().toLowerCase() === email.trim().toLowerCase() &&
    value.expiresAt > Date.now() / 1000
  )
    return `/oauth/interaction/${value.interactionId}`
  return undefined
}
